import script from "./BlockRepeat.vue?vue&type=script&setup=true&lang=js"
export * from "./BlockRepeat.vue?vue&type=script&setup=true&lang=js"

import "./BlockRepeat.vue?vue&type=style&index=0&id=5be62364&lang=css"

const __exports__ = script;

export default __exports__